import * as React from 'react';
import { ILinkedRoute } from 'src/modules/Routing/types';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RouteModuleContext } from 'src/modules/Routing/context/RouteModule';
import { linkRoutes } from 'src/modules/Routing/hooks/routes/linkRoutes';

export const useRoutes = (): [ILinkedRoute[], UserTypes] => {
  const [routeModules, userType] = React.useContext(RouteModuleContext)
  const routes = React.useMemo(() => linkRoutes(routeModules), [routeModules])
  return [routes, userType];
}



// WEBPACK FOOTER //
// ./src/modules/Routing/hooks/routes/useRoutes.ts